import axios from 'axios';
import { BASE_URL } from './api';

export async function getCompanyLocations(token, queryParams) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/company-locations${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
    });
}
